import script from "./SignaturePad.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignaturePad.vue?vue&type=script&setup=true&lang=ts"

import "./SignaturePad.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__